export function formatPrice(value) {
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
  }).format(Number(value || 0));
}

export function priceRange(product) {
  if (product.priceFrom === product.priceTo) return formatPrice(product.priceFrom);
  return `${formatPrice(product.priceFrom)} — ${formatPrice(product.priceTo)}`;
}

export function discountPercent(price, regularPrice) {
  const reference = Number(regularPrice);
  const current = Number(price);
  if (!Number.isFinite(reference) || reference <= 0 || !Number.isFinite(current)) return 0;
  return Math.max(0, Math.round((1 - current / reference) * 100));
}

export function clampQuantity(value) {
  const quantity = Number.parseInt(value, 10);
  if (Number.isNaN(quantity)) return 1;
  return Math.min(100, Math.max(1, quantity));
}
